import { render, staticRenderFns } from "./SelectInputResourcefulV3.vue?vue&type=template&id=6a4ee491&scoped=true&"
import script from "./SelectInputResourcefulV3.vue?vue&type=script&lang=js&"
export * from "./SelectInputResourcefulV3.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputResourcefulV3.vue?vue&type=style&index=0&id=6a4ee491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ee491",
  null
  
)

export default component.exports